/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { decorators } from '@codegrade/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const { nonenumerable } = decorators;
